module.exports = __webpack_public_path__ + "img/speed_bad.d533f483.svg";